 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPSCOVERPAGE from '@/components/OEBPS/Coverpage'
 import LOVE_1 from '@/components/love_1'
 import OEBPS9780230617063_01_TIT from '@/components/OEBPS/9780230617063_01_tit'
 import OEBPSNOTICE from '@/components/OEBPS/notice'
 import OEBPS9780230617063_03_DED from '@/components/OEBPS/9780230617063_03_ded'
 import OEBPS9780230617063_04_TOC from '@/components/OEBPS/9780230617063_04_toc'
 import OEBPS9780230617063_05_LIST from '@/components/OEBPS/9780230617063_05_list'
 import OEBPS9780230617063_06_PRO from '@/components/OEBPS/9780230617063_06_pro'
 import OEBPS9780230617063_07_INT from '@/components/OEBPS/9780230617063_07_int'
 import OEBPS9780230617063_08_PA01 from '@/components/OEBPS/9780230617063_08_pa01'
 import OEBPS9780230617063_09_CH01 from '@/components/OEBPS/9780230617063_09_ch01'
 import OEBPS9780230617063_10_CH02 from '@/components/OEBPS/9780230617063_10_ch02'
 import OEBPS9780230617063_11_CH03 from '@/components/OEBPS/9780230617063_11_ch03'
 import OEBPS9780230617063_12_PA02 from '@/components/OEBPS/9780230617063_12_pa02'
 import OEBPS9780230617063_13_CH04 from '@/components/OEBPS/9780230617063_13_ch04'
 import OEBPS9780230617063_14_CH05 from '@/components/OEBPS/9780230617063_14_ch05'
 import OEBPS9780230617063_15_CH06 from '@/components/OEBPS/9780230617063_15_ch06'
 import OEBPS9780230617063_16_PA03 from '@/components/OEBPS/9780230617063_16_pa03'
 import OEBPS9780230617063_17_CH07 from '@/components/OEBPS/9780230617063_17_ch07'
 import OEBPS9780230617063_18_CH08 from '@/components/OEBPS/9780230617063_18_ch08'
 import OEBPS9780230617063_19_CH09 from '@/components/OEBPS/9780230617063_19_ch09'
 import OEBPS9780230617063_20_EPI from '@/components/OEBPS/9780230617063_20_epi'
 import LOVE_2 from '@/components/love_2'
 import OEBPS9780230617063_21_TIM from '@/components/OEBPS/9780230617063_21_tim'
 import OEBPS9780230617063_22_HIS from '@/components/OEBPS/9780230617063_22_his'
 import OEBPS9780230617063_23_NOT from '@/components/OEBPS/9780230617063_23_not'
 import OEBPS9780230617063_24_SEL from '@/components/OEBPS/9780230617063_24_sel'
 import OEBPS9780230617063_25_ACK from '@/components/OEBPS/9780230617063_25_ack'
 import OEBPS9780230617063_26_IND from '@/components/OEBPS/9780230617063_26_ind'
 import OEBPS9780230617063_02_CPY from '@/components/OEBPS/9780230617063_02_cpy'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/Coverpage",
 			"name" : "OEBPS/Coverpage",
 			"component" : OEBPSCOVERPAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/OEBPS/9780230617063_01_tit",
 			"name" : "OEBPS/9780230617063_01_tit",
 			"component" : OEBPS9780230617063_01_TIT
 		},
 		{
 			"path" : "/OEBPS/notice",
 			"name" : "OEBPS/notice",
 			"component" : OEBPSNOTICE
 		},
 		{
 			"path" : "/OEBPS/9780230617063_03_ded",
 			"name" : "OEBPS/9780230617063_03_ded",
 			"component" : OEBPS9780230617063_03_DED
 		},
 		{
 			"path" : "/OEBPS/9780230617063_04_toc",
 			"name" : "OEBPS/9780230617063_04_toc",
 			"component" : OEBPS9780230617063_04_TOC
 		},
 		{
 			"path" : "/OEBPS/9780230617063_05_list",
 			"name" : "OEBPS/9780230617063_05_list",
 			"component" : OEBPS9780230617063_05_LIST
 		},
 		{
 			"path" : "/OEBPS/9780230617063_06_pro",
 			"name" : "OEBPS/9780230617063_06_pro",
 			"component" : OEBPS9780230617063_06_PRO
 		},
 		{
 			"path" : "/OEBPS/9780230617063_07_int",
 			"name" : "OEBPS/9780230617063_07_int",
 			"component" : OEBPS9780230617063_07_INT
 		},
 		{
 			"path" : "/OEBPS/9780230617063_08_pa01",
 			"name" : "OEBPS/9780230617063_08_pa01",
 			"component" : OEBPS9780230617063_08_PA01
 		},
 		{
 			"path" : "/OEBPS/9780230617063_09_ch01",
 			"name" : "OEBPS/9780230617063_09_ch01",
 			"component" : OEBPS9780230617063_09_CH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js